/* @flow */
// typecheck: ignore file
import { Map } from 'immutable';
import type { Action } from 'action';
import Organization from 'entities/Organization';
import type { ClassMembershipFetchOptions } from 'sagas/peopleTables';

export type SchoolTable = {|
  page: number,
  loading: boolean,
  allLoaded: boolean,
  schools: Organization[],
|};

export type State = Map<number, SchoolTable>;
export const initialState: State = new Map();

export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'schoolTables/INITIALIZE_TABLE': {
      return state.set(action.districtId, {
        page: 1,
        schools: [],
        loading: false,
        allLoaded: false,
      });
    }

    case 'schoolTables/LOAD_SCHOOLS_REQUEST': {
      const table = state.get(action.districtId);
      return state.set(action.districtId, {
        ...table,
        loading: true,
      });
    }

    case 'schoolTables/LOAD_SCHOOLS_SUCCESS': {
      const table = state.get(action.districtId);
      return state.set(action.districtId, {
        ...table,
        loading: false,
        page: action.options.page,
        allLoaded: action.schools.length < action.options.perPage,
        schools: action.options.page === 1 ? action.schools : [].concat(table.schools, action.schools),
      });
    }

    default: {
      return state;
    }
  }
}

type InitializeTableAction = {
  type: 'schoolTables/INITIALIZE_TABLE',
  districtId: number,
};

export function initializeTable(districtId: number): InitializeTableAction {
  return {
    type: 'schoolTables/INITIALIZE_TABLE',
    districtId,
  };
}

export type LoadSchoolsAction = {
  type: 'schoolTables/LOAD_SCHOOLS_REQUEST',
  districtId: number,
  options: any,
};

export function loadSchools(districtId: number, options: ClassMembershipFetchOptions): LoadSchoolsAction {
  return {
    type: 'schoolTables/LOAD_SCHOOLS_REQUEST',
    districtId,
    options,
  };
}

export type LoadSchoolsSuccessAction = {
  type: 'schoolTables/LOAD_SCHOOLS_SUCCESS',
  districtId: number,
  schools: Organization[],
  options: ClassMembershipFetchOptions,
};

export function loadSchoolsSuccess(districtId: number, schools: Organization[], options: ClassMembershipFetchOptions): LoadSchoolsSuccessAction {
  return {
    type: 'schoolTables/LOAD_SCHOOLS_SUCCESS',
    districtId,
    schools,
    options,
  };
}

export type SchoolTablesAction =
  InitializeTableAction |
  LoadSchoolsAction |
  LoadSchoolsSuccessAction;



// WEBPACK FOOTER //
// ./src/reducers/schoolTables.js